import messagingProviders from './messagingProviders'
import customers from './customers'
import addresses from './addresses'
import companies from './companies'
import identityUsers from './identityUsers'

const user = {
  messagingProviders,
  customers,
  companies,
  addresses,
  identityUsers,
}

export default user
